// This implementation is obviously limited but is useful enough for most things
export const pluralize = (count: number, word: string) => {
  return count === 1 || word.endsWith("s") ? word : `${word}s`;
};
